/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon20Regular = forwardRef('MathSumIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.487 4.624C2.452 3.709 3.099 2 4.481 2H15.25a.75.75 0 0 1 0 1.5H4.48l6.081 5.376a1.5 1.5 0 0 1 0 2.248L4.481 16.5H15.25a.75.75 0 0 1 0 1.5H4.48c-1.38 0-2.028-1.709-.993-2.624L9.567 10l-6.08-5.376Z" })));
});
